var map = {
	"./Jason.png": "fc7e",
	"./Ryo.png": "d48e",
	"./Sokchanlida.png": "fda1",
	"./Sorida.png": "5259",
	"./Soukhim.png": "2e26",
	"./Vannak.png": "0611",
	"./heang_chanthy.png": "8f17"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1179";